var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structureTreeMini"},[_c('div',{staticClass:"treeContainer"},[_c('div',{ref:"treeChart",staticClass:"treeChart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }